import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="contact-info">
          Questions or feedback? Contact the dev on Discord: <strong>.ijake.</strong>
        </p>
        <p className="data-attribution">
          Card recommendations powered by <a href="https://edhrec.com" target="_blank" rel="noopener noreferrer">EDHREC</a>. Card images and data from <a href="https://scryfall.com" target="_blank" rel="noopener noreferrer">Scryfall</a>. Thank you for providing these amazing resources!
        </p>
        <p className="affiliate-disclosure">
          EDH.Build is part of the following affiliate programs and may earn a commission from qualifying purchases: TCGplayer
        </p>
        <p>
          Wizards of the Coast, Magic: The Gathering, and their logos are trademarks of Wizards of the Coast LLC. © 2025 Wizards. All rights reserved.
        </p>
        <p>
          The copyright for Magic: the Gathering and all associated card names and card images is held by Wizards of the Coast.
        </p>
        <p>
          EDH.Build is unofficial Fan Content permitted under the <a href="http://company.wizards.com/fancontentpolicy" target="_blank" rel="noopener noreferrer">Fan Content Policy</a>. Not approved/endorsed by Wizards.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
